import { Button, Checkbox, Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { TRY_THEN_BUY_FRAUD } from '../../../../constants/define/translation';

interface FormReasonProps {
  onSubmit: (value: string) => void;
  label: string;
  placeholder: string;
  validateMessage: string;
}
export const FormReason = (props: FormReasonProps) => {
  const [form] = Form.useForm();
  const { onSubmit, label, placeholder, validateMessage } = props;
  const { t } = useTranslation(TRY_THEN_BUY_FRAUD);
  return (
    <StyledContainer>
      <Form layout="vertical" form={form} onFinish={onSubmit}>
        <div className="form-content py-2">
          <Form.Item name="reason" label={label} rules={[{ required: true, message: validateMessage }]}>
            <TextArea placeholder={placeholder} showCount maxLength={10000} />
          </Form.Item>
          <Form.Item name="blacklist" valuePropName="checked">
            <Checkbox className="blacklist">{t('table.popup.blacklist')}</Checkbox>
          </Form.Item>
          <div className="mt-2">
            <Form.Item shouldUpdate>
              {() => (
                <div className="d-flex justify-content-end mt-3">
                  <Button
                    type="primary"
                    size="large"
                    disabled={
                      !form.isFieldTouched('reason') ||
                      !!form.getFieldsError().filter(({ errors }) => errors.length).length
                    }
                    id="btnSubmitInput"
                    className="px-4 btn mt-3"
                    htmlType="submit"
                  >
                    {t('form.submit')}
                  </Button>
                </div>
              )}
            </Form.Item>
          </div>
        </div>
      </Form>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  .blacklist {
    font-weight: bold;
  }
`;
